export default "__VITE_ASSET__C1Oq4aoz__"